import { Component } from '@angular/core';
import { IzzyTicketTeamEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Ticket Teams') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyticketteam-form',
    templateUrl: './izzyticketteam.form.component.html'
})
export class IzzyTicketTeamFormComponent extends BaseFormComponent {
    public record!: IzzyTicketTeamEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'teamConfiguration', sectionName: 'Team Configuration', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false },
            { sectionKey: 'macros', sectionName: 'Macros', isExpanded: false },
            { sectionKey: 'ticketTeamMembers', sectionName: 'Ticket Team Members', isExpanded: false },
            { sectionKey: 'sLAPolicies', sectionName: 'SLA Policies', isExpanded: false }
        ]);
    }
}

